import consolidateLocale from './lib/consolidateLocale';
import exportLocale from './lib/exportLocale';
import importLocale from './lib/importLocale';
import localeLoader from './lib/localeLoader';
import transformLoader from './lib/transformLoader';

export {
  exportLocale,
  importLocale,
  consolidateLocale,
  transformLoader,
  localeLoader as default,
};
